module.exports = __webpack_public_path__ + "img/html5_new.37f6a7ce.png";